"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _Item = _interopRequireDefault(require("./Item"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _DarkMobileSelect = require("./DarkMobileSelect.style");

var _class, _class2, _temp;

var DarkMobileSelect = (0, _emotionTheming.withTheme)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DarkMobileSelect, _PureComponent);

  function DarkMobileSelect() {
    (0, _classCallCheck2.default)(this, DarkMobileSelect);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DarkMobileSelect).apply(this, arguments));
  }

  (0, _createClass2.default)(DarkMobileSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          iconType = _this$props.iconType,
          title = _this$props.title,
          style = _this$props.style,
          className = _this$props.className,
          onChangeHandler = _this$props.onChangeHandler,
          children = _this$props.children;
      _Item.default.onChangeHandler = onChangeHandler;

      var childrenWithProps = _react.default.Children.map(children, function (child) {
        return _react.default.cloneElement(child, {
          title: title
        });
      });

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className, (0, _DarkMobileSelect.rootStyle)(theme), style)
      }, _react.default.createElement("div", {
        className: _DarkMobileSelect.titleContainerStyle
      }, iconType && _react.default.createElement(_Icon.default, {
        type: iconType,
        className: (0, _DarkMobileSelect.iconStyle)(theme)
      }), _react.default.createElement("span", {
        className: _DarkMobileSelect.titleStyle
      }, title)), _react.default.createElement("div", {
        className: (0, _DarkMobileSelect.separatorStyle)(theme)
      }), childrenWithProps);
    }
  }]);
  return DarkMobileSelect;
}(_react.PureComponent), (0, _defineProperty2.default)(_class2, "Item", _Item.default), _temp)) || _class;

DarkMobileSelect.propTypes = {
  iconType: _propTypes.default.string,
  title: _propTypes.default.string,
  style: _propTypes.default.object,
  className: _propTypes.default.string
};
DarkMobileSelect.defaultProps = {
  iconType: '',
  title: 'Mobile Select',
  style: {},
  className: ''
};
var _default = DarkMobileSelect;
exports.default = _default;